import {Component} from '@angular/core';
import {BaseErrorDetailComponent} from '../common/base-error-detail/base-error-detail.component';
import {Exception} from '../../models/error/Exception';
import {ExceptionService} from '../../services/error/exception.service';
import {ErrorDetailTemplateComponent} from '../common/error-detail-template/error-detail-template.component';
import {ErrorDetailRuleComponent} from '../common/error-detail-rule/error-detail-rule.component';
import {IonContent} from '@ionic/angular/standalone';
import {CommonModule} from '@angular/common';
import {HeaderComponent} from '../common/header/header.component';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
    selector: 'app-exception-detail',
    standalone: true,
    imports: [ErrorDetailTemplateComponent, ErrorDetailRuleComponent, IonContent, CommonModule, HeaderComponent, TranslatePipe],
    templateUrl: './exception-detail.component.html',
    styleUrl: './exception-detail.component.css'
})
export class ExceptionDetailComponent extends BaseErrorDetailComponent<Exception> {
    constructor(private exceptionService: ExceptionService) {
        super(exceptionService);
    }
}
